import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterExpenses } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import {saveAs} from 'file-saver';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-transacao-saldo-alocado',
  templateUrl: './transacao-saldo-alocado.component.html',
  styleUrls: ['./transacao-saldo-alocado.component.css']
})
export class TransacaoSaldoAlocadoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    public datepipe: DatePipe,
    private modalService: NgbModal
  ) { }

  public currentUser: Auth;
  public filtro = new FilterExpenses(null,null,null);
  public expenses: any;
  public filtroOn: boolean = false;
  
  public collaboratorCtrl: FormControl = new FormControl();

  queryDate: Date;
  
  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();

  public mask = [/[1-9]/, /\d/, /\d/, /\d/,' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  
  public panMask = ['*','*','*','*',' ','*','*','*','*',' ','*','*','*','*',' ', /[1-9]/, /\d/, /\d/, /\d/]

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.dataInicio.setDate(this.dataInicio.getDate()-30);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.filtroOn = true;
    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getAllocatedBalanceTransactions(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.expenses = response.result.items;
        this.totalItems = response.result.totalItems;     
        this.queryDate = new Date();        
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }

  applyFilter() {
    this.filtro.collaborator = this.collaboratorCtrl.value;
    if(
      this.filtro.dateStart == null &&
      this.filtro.dateStart == null &&
      this.filtro.collaborator == null
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtroOn = false;
    this.filtro = new FilterExpenses(this.dataInicio,this.dataFim,null);

    this.dataMaxima = this.dataFim;

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  exportExcel(){
  var result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const excelService = new ExcelService();
  const worksheets = new Array<WorksheetData>();
  const ws = new WorksheetData();
  ws.worksheetTitle = 'transacoes_despesas_' + date[2] + '-' + date[1] + '-' + date[0];
  ws.worksheetHeaders = ['#','Favorecido','Valor','Data e hora','Final do Cartão','Destino'];
  ws.WorksheetRows = [];

  this.relatorioService.getAllocatedBalanceTransactions(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.items;      
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.transactionCode.toString());
        lr.push(r.collaborator);
        lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
        lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss'));
        lr.push(r.pan);
        lr.push(r.receipter);
        ws.WorksheetRows.push(lr);
      });

      worksheets.push(ws);

      // let filter = '';
      // filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
      
      excelService.generateExcelReport('Transações de Despesas', worksheets, null).xlsx
      .writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, ws.worksheetTitle + '.xlsx');
      });

    }
  },
  error => {
    this.alertService.error('Ocorreu um erro ao paginar relatorio');
  });
}

exportPdf(){
  let result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const pdfData = new PdfData();
  pdfData.PdfTitle = 'transacoes_despesas_' + date[2] + '-' + date[1] + '-' + date[0];
  pdfData.PdfHeaders = ['#','Favorecido','Valor','','Data e hora','Final do Cartão','Destino'];
  pdfData.PdfRows = [];

  this.relatorioService.getAllocatedBalanceTransactions(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.items;       
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.transactionCode.toString());
        lr.push(r.collaborator);
        lr.push('R$');
        lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
        lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss'));
        lr.push(r.pan);
        lr.push(r.receipter);
        pdfData.PdfRows.push(lr);
      });

      let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
      filter += this.filtro.collaborator != null ? ' - Favorecido: ' + this.filtro.collaborator : '';

      const pdfService = new PdfService();
      pdfService.generatePdfReport('Transações de Despesas',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
        saveAs(blob, pdfData.PdfTitle + '.pdf');
      });

    } else {
      this.alertService.error(response.message);
    }
  },
  error => {
    this.alertService.error(
      'Ocorreu um erro ao paginar o relatorio'
    );
  });
}
}
